import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company */}
          <div className="footer-column">
            <h3>Orient Button Limited</h3>
            <p className="footer-description">
              Premium plastic button manufacturing for fashion, garments, and accessories.
              Quality, precision, and sustainability.
            </p>
          </div>

          {/* Products */}
          <div className="footer-column">
            <h4>Products</h4>
            <ul>
              <li><Link to="/products?category=Pearl">Pearl Buttons</Link></li>
              <li><Link to="/products?category=Chalk">Chalk Buttons</Link></li>
              <li><Link to="/products?category=Horn">Horn Buttons</Link></li>
              <li><Link to="/products?category=Fancy">Fancy Buttons</Link></li>
              <li><Link to="/products?category=Laser%20Engraved">Laser Engraved</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/process">Manufacturing</Link></li>
              <li><Link to="/sustainability">Sustainability</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/quote">Request a Quote</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-column">
            <h4>Contact</h4>
            <address>
              <p>📍 Orient Button Limited</p>
              <p>Demra, Dhaka, Bangladesh</p>
              <p>📞 +880 1856-392630</p>
              <p>✉️ info@orientbutton.com</p>
              <p>💬 WhatsApp: +880 1856-392630</p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>© 2026 Orient Button Limited. All Rights Reserved.</p>
          <div className="footer-social">
            <a href="#" aria-label="Facebook">📘</a>
            <a href="#" aria-label="Instagram">📸</a>
            <a href="#" aria-label="LinkedIn">💼</a>
            <a href="#" aria-label="YouTube">▶️</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;